module.exports = __webpack_public_path__ + "static/media/04.9611cf95.jpg";